import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.SignupLoginModule.SignupModule', {
    emailRequired: 'Your email address is required.',
    emailInvalid: 'The email address is not valid.',
    emailPlaceholder: 'Enter your email address',
    title: 'Enter your business email',
    consentMarketingText: "I agree to receive ApprovalMax's news, insights and special offers",
    signupButtonText: 'Sign up for free',
    startTrial: 'Start a free 14-day trial',
    advantages1: 'No credit card required',
    advantages2: 'Unlimited users',
    advantages3: 'Cancel at any time',
});
